import { useEffect, useState } from "react";

interface ElectronAPI {
  platform: string;

  isElectron: boolean;

  minimizeWindow: () => Promise<void>;

  toggleMaximizeWindow: () => Promise<void>;

  closeWindow: () => Promise<void>;

  getWindowState: () => Promise<{ isMaximized: boolean; isMinimized: boolean }>;

  onWindowStateChange: (
    callback: (
      event: unknown,
      data: { isMaximized: boolean; isMinimized: boolean },
    ) => void,
  ) => void;
}

function getElectronAPI(): ElectronAPI | null {
  const api = (window as unknown as { electronAPI?: ElectronAPI }).electronAPI;

  return api?.isElectron ? api : null;
}

export function useWindowControls() {
  const [isMaximized, setIsMaximized] = useState(false);

  const electronAPI = getElectronAPI();

  const isElectron = !!electronAPI;

  useEffect(() => {
    electronAPI?.onWindowStateChange((_event, data) => {
      setIsMaximized(data.isMaximized);
    });
  }, [electronAPI]);

  const handleMinimize = () => electronAPI?.minimizeWindow();

  const handleToggleMaximize = () => electronAPI?.toggleMaximizeWindow();

  const handleClose = () => electronAPI?.closeWindow();

  return {
    isElectron,
    isMaximized,
    handleMinimize,
    handleToggleMaximize,
    handleClose,
  };
}
